import { render, staticRenderFns } from "./chatAuditorium.vue?vue&type=template&id=3aa2c2ab&scoped=true"
import script from "./chatAuditorium.vue?vue&type=script&lang=js"
export * from "./chatAuditorium.vue?vue&type=script&lang=js"
import style0 from "./chatAuditorium.vue?vue&type=style&index=0&id=3aa2c2ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2c2ab",
  null
  
)

export default component.exports